export const isa = <T>(allowed: readonly T[], value: any): value is T =>
  (allowed as any[]).includes(value);

export const isKeyOf = <T>(allowed: T, value: any): value is keyof T =>
  !!allowed &&
  typeof value === "string" &&
  !!Object.getOwnPropertyDescriptor(allowed, value);

export const isDefined = <T>(value: T): value is NonNullable<T> =>
  value !== undefined && value !== null;

export const isArrayOf = <T>(
  value: any,
  checker: (value: any) => boolean
): value is T[] => Array.isArray(value) && value.every(checker);

/** Type guard for fulfilled {@link PromiseSettledResult} objects */
export const isFulfilled = <T>(
  input: PromiseSettledResult<T>
): input is PromiseFulfilledResult<T> => input.status === "fulfilled";

/** Type guard for rejected {@link PromiseSettledResult} objects */
export const isRejected = <T>(
  input: PromiseSettledResult<T>
): input is PromiseRejectedResult => input.status === "rejected";

/** Type guard for arrays of minimum length */
export const isNonEmpty = <T>(input: T[]): input is [T, ...T[]] =>
  !!input.length;
